import { useMatchPath } from "./useMatchPath";

export const useLocationPath = () => {
  return useMatchPath<{
    clientId: string;
    projectId: string;
    locationId: string;
  }>("/clients/:clientId/projects/:projectId/train/locations/:locationId");
};
